export default function(el) {
    if (!el.dataset.src) return;

    const src = el.dataset.src;
    const content = el.querySelector(".ev__content");
    const loader = el.querySelector(".ev__loader");

    if (content) content.insertAdjacentHTML("afterbegin", src);

    if (loader) loader.parentElement.removeChild(loader);
}
